module.exports = __webpack_public_path__ + "static/media/product.b215ec25.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/aiSoc/product.png
// module id = 625
// module chunks = 0